import NivelUsuario from '../NivelUsuario'
import BarraProgressoCircular from '../BarraProgressoCircular';


function DesempenhoAnimalUsuario({ dados }) {
    console.log(dados.nivelRealizado);

    function formatarValorProgresso(valor) {
        try {

            if (dados.formatacao.valores === 'quantidade') {
                return parseInt(valor);
            }

            if (dados.formatacao.valores === 'percentual') {
                return `${(parseFloat(valor)).toFixed(2).replace('.', ',')}%`;
            }

            if (dados.formatacao.valores === 'moeda') {
                return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor);
            }
        } catch (error) {
            console.error('Erro: ' + error.message);
        }
    }

    function formatarValorMeta(valor) {
        try {
            if (dados.formatacao.metas === 'quantidade') {
                return parseInt(valor);
            }

            if (dados.formatacao.metas === 'percentual') {
                return `${(parseFloat(valor)).toFixed(2).replace('.', ',')}%`;
            }

            if (dados.formatacao.metas === 'moeda') {
                return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor);
            }
        } catch (error) {
            console.error('Erro: ' + error.message);
        }
    }

    function formatarPontuacao(pontos) {
        try {
            if (pontos > 0) {
                return '+ ' + pontos + ' pontos';
            }

            return pontos + ' pontos';
        } catch (error) {
            console.error('Erro: ' + error.message)
        }
    }

    function getCorPorNivel(nivel) {
        switch (nivel) {
            case 'E':
                return '#7030a0';
            case 'D':
                return '#ff0000';
            case 'C':
                return '#ffff00';
            case 'B':
                return '#99ff99';
            case 'A':
                return '#bdd7ee';
            default:
                return '#949494';
        }
    }

    function converteDatas() {
        try {
            const [mes, ano] = dados.mesAno.split('-');
            let numeroMes = parseInt(mes, 10);
            let numeroAno = parseInt(ano, 10);

            // Se o mês for janeiro, ajuste para dezembro do ano anterior
            if (numeroMes === 1) {
                numeroMes = 12;
                numeroAno -= 1;
            } else {
                numeroMes -= 1;
            }

            // Obtém o nome do mês por extenso
            const nomeMeses = [
                'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
                'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
            ];

            return {

                anoMesAnterior: numeroAno,
                anoAnterior: ano - 1,
                nomeMesAtual: nomeMeses[mes - 1],
                nomeMesAnterior: nomeMeses[numeroMes - 1],
                anoAtual: ano
            }
        } catch (error) {
            console.error('Erro: ' + error.message)
        }
    }

    function calculaMesAnterior() {
        try {
            let valor = 0;
            let tipo = 'Mês Anterior';

            if (dados.mesAnteriorParcial >= 0) {
                valor = dados.mesAnteriorParcial;
                tipo = 'Parcial';
            }

            if (dados.mesAnteriorTotal >= 0) {
                valor = dados.mesAnteriorTotal;
                tipo = 'Total';
            }

            return {
                valor: valor,
                tipo: tipo
            }
        } catch (error) {
            console.error('Erro: ' + error.message)
        }
    }

    function calcularMesAtualAnoAnterior() {
        try {
            let valor = 0;
            let tipo = 'Mês Atual Ano Anterior';

            if (dados.mesAtualAnoAnteriorParcial >= 0) {
                valor = dados.mesAtualAnoAnteriorParcial;
                tipo = 'Parcial';
            }

            if (dados.mesAtualAnoAnteriorTotal >= 0) {
                valor = dados.mesAtualAnoAnteriorTotal;
                tipo = 'Total';
            }

            return {
                valor: valor,
                tipo: tipo
            }
        } catch (error) {
            console.error('Erro: ' + error.message)
        }
    }

    function formataDiferencaMesAtual(valor) {
        try {
            const percentualDiferencaMesAtual = valor;

            if (percentualDiferencaMesAtual < 0) {
                return {
                    msg: `${percentualDiferencaMesAtual.toFixed(2).replace('.', ',').replace('-', '')}% `,
                    arrow: <span>&#9662;</span>,
                    positivo: false
                }
            }

            if (percentualDiferencaMesAtual > 0) {
                return {
                    msg: `${percentualDiferencaMesAtual.toFixed(2).replace('.', ',')}%`,
                    arrow: <span>&#9652;</span>,
                    positivo: true
                }
            }


            return {
                msg: `0%`,
                arrow: <span>&#9652;</span>,
                positivo: true
            }
        } catch (error) {
            console.error('Erro: ' + error.message)
        }
    }

    function getTamanhoDivResumoDetalhes() {
        if (dados.cargo === 'GERENTE_REGIONAL') {
            return 70;
        } else {
            return 62;
        }
    }

    return (
        <div>
            <div className="font-poppins text-center text-gray-c5">
                <h1 className="font-semibold text-[60px]">{dados.animal}</h1>
                <h2 className="font-semibold text-2xl">Indicador: {dados.indicador}</h2>

                <div className="flex justify-center">
                    <div className="mr-4">
                        <NivelUsuario tipo="Realizado" nivel={dados.card.nivelRealizado} pontos={formatarPontuacao(dados.card.pontuacaoRealizada)} />
                    </div>
                    <div>
                        <NivelUsuario tipo="Projetado" nivel={dados.card.nivelProjetado} pontos={formatarPontuacao(dados.card.pontuacaoProjetada)} />
                    </div>
                </div>

                <div className="flex justify-center">
                    <div className="mr-4">
                        <p className="font-medium text-lg pb-1">Realizado:</p>
                        <BarraProgressoCircular percentage={parseFloat(dados.card.percentualRealizado)} color={getCorPorNivel(dados.card.nivelRealizado)} styleWidth="172px" />
                    </div>
                    <div>
                        <p className="font-medium text-lg pb-14">Projetado:</p>
                        <BarraProgressoCircular percentage={parseFloat(dados.card.percentualProjetado)} color={getCorPorNivel(dados.card.nivelProjetado)} styleWidth="172px" />
                    </div>
                </div>
            </div>

            <div className="text-center py-12">
                <div className="font-poppins font-normal text-base text-gray-c13 bg-gradient-to-b from-white to-gray-c15 inline-block px-4 py-1.5 rounded-t-lg border border-t-gray-c16 border-x-gray-c16">
                    <p className="inline-block">Seu progresso no mês de <span className="text-gray-c14 font-bold">{converteDatas().nomeMesAtual + ' de ' + converteDatas().anoAtual}</span></p>
                </div>

                <div className={`grid grid-cols-1 md:grid-cols-1 max-w-full lg:max-w-[${getTamanhoDivResumoDetalhes()}%] mx-auto mt-[-3px] bg-white lg:bg-white rounded-lg relative z-10`}>
                    <div className="flex flex-col md:flex-row items-center justify-between font-mulish text-center px-8 py-7">

                        <div className="font-extrabold mb-4">
                            <p className="text-[15px] text-gray-c14">Missão do Mês:</p>
                            <h4 className="text-[27px] text-gray-c17">{formatarValorProgresso(dados.card.metaPrincipal)}</h4>
                        </div>
                        <div className="font-extrabold mb-4">
                            <p className="text-[15px] text-gray-c14">Realizado:</p>
                            <h4 className="text-[27px] text-green-c1">{formatarValorProgresso(dados.card.realizado)}</h4>
                        </div>
                        <div className="font-extrabold mb-4">
                            <p className="text-[15px] text-gray-c14">Projetado:</p>
                            <h4 className="text-[27px] text-green-c1">{formatarValorProgresso(dados.card.projetado)}</h4>
                        </div>

                        <div className="font-extrabold mb-4">
                            <p className="text-[15px] text-gray-c14">{calculaMesAnterior().tipo} - {converteDatas().nomeMesAnterior}/{converteDatas().anoMesAnterior}:</p>
                            <h4 className="text-[27px] text-gray-c17">{formatarValorProgresso(calculaMesAnterior().valor)}
                                <label className={`text-[8px] text-${formataDiferencaMesAtual(dados.percentualDiferencaMesAnterior).positivo ? 'green' : 'red'}-c1`}>
                                    {formataDiferencaMesAtual(dados.percentualDiferencaMesAnterior).arrow}{formataDiferencaMesAtual(dados.percentualDiferencaMesAnterior).msg}
                                </label>
                            </h4>
                        </div>


                        <div className="font-extrabold mb-4">
                            <p className="text-[15px] text-gray-c14">{calcularMesAtualAnoAnterior().tipo} - {converteDatas().nomeMesAtual}/{converteDatas().anoAnterior}:</p>
                            <h4 className="text-[27px] text-gray-c17">{formatarValorProgresso(calcularMesAtualAnoAnterior().valor)}
                                <label className={`text-[8px] text-${formataDiferencaMesAtual(dados.percentualDiferencaMesAtualAnoAnterior).positivo ? 'green' : 'red'}-c1`}>
                                    {formataDiferencaMesAtual(dados.percentualDiferencaMesAtualAnoAnterior).arrow}{formataDiferencaMesAtual(dados.percentualDiferencaMesAtualAnoAnterior).msg}
                                </label>
                            </h4>
                        </div>

                    </div>
                    
                    {(dados.cargo === 'GERENTE_LOJA' && [1, 2, 3].includes(dados.idAnimal)) && (
                        <div className='mb-4 font-extrabold justify-between font-mulish text-center items-center px-8'>
                            <p className="text-[15px] text-red-c1">* Valores em média por vendedores da filial.</p>
                        </div>
                    )}
                </div>
            </div>

            {dados.cargo === 'GERENTE_LOJA' && [1, 2, 3].includes(dados.idAnimal) && (
                <div className="text-center py-12">
                    <div className="font-poppins font-normal text-base text-gray-c13 bg-gradient-to-b from-white to-gray-c15 inline-block px-4 py-1.5 rounded-t-lg border border-t-gray-c16 border-x-gray-c16">
                        <p className="inline-block">Progresso da filial no mês de <span className="text-gray-c14 font-bold">{converteDatas().nomeMesAtual + ' de ' + converteDatas().anoAtual}</span></p>
                    </div>
                    <div className={`grid grid-cols-1 md:grid-cols-1 max-w-full lg:max-w-[${getTamanhoDivResumoDetalhes()}%] mx-auto mt-[-3px] bg-white lg:bg-white rounded-lg relative z-10`}>
                        <div className="flex flex-col md:flex-row items-center justify-between font-mulish text-center px-8 py-7">
                            <div className="font-extrabold mb-4">
                                <p className="text-[15px] text-gray-c14">Quantidade Vendedores:</p>
                                <h4 className="text-[27px] text-gray-c1">{dados.quantidadeVendedores}</h4>
                            </div>
                            <div className="font-extrabold mb-4">
                                <p className="text-[15px] text-gray-c14">Realizado Filial:</p>
                                <h4 className="text-[27px] text-green-c1">{formatarValorProgresso(dados.realizadoFilial)}</h4>
                            </div>
                            <div className="font-extrabold mb-4">
                                <p className="text-[15px] text-gray-c14">Projetado Filial:</p>
                                <h4 className="text-[27px] text-green-c1">{formatarValorProgresso(dados.projetadoFilial)}</h4>
                            </div>
                            <div className="font-extrabold mb-4">
                                <p className="text-[15px] text-gray-c14"> Filial {dados.mesAnteriorParcialFilial >= 0 ? 'Parcial' : 'Total'} - {converteDatas().nomeMesAnterior}/{converteDatas().anoMesAnterior}:</p>
                                <h4 className="text-[27px] text-gray-c1">{dados.mesAnteriorParcialFilial >= 0 ? formatarValorProgresso(dados.mesAnteriorParcialFilial) : formatarValorProgresso(dados.mesAnteriorTotalFilial)}
                                    <label className={`text-[8px] text-${formataDiferencaMesAtual(dados.percentualDiferencaMesPassadoFilial).positivo ? 'green' : 'red'}-c1`}>
                                        {formataDiferencaMesAtual(dados.percentualDiferencaMesPassadoFilial).arrow}{formataDiferencaMesAtual(dados.percentualDiferencaMesPassadoFilial).msg}
                                    </label>
                                </h4>
                            </div>
                            <div className="font-extrabold mb-4">
                                <p className="text-[15px] text-gray-c14">Filial {dados.mesAtualAnoAnteriorParcialFilial >= 0 ? 'Parcial' : 'Total'} - {converteDatas().nomeMesAtual}/{converteDatas().anoAnterior}:</p>
                                <h4 className="text-[27px] text-gray-c1">{dados.mesAtualAnoAnteriorParcialFilial >= 0 ? formatarValorProgresso(dados.mesAtualAnoAnteriorParcialFilial) : formatarValorProgresso(dados.mesAtualAnoAnteriorTotalFilial)}
                                    <label className={`text-[8px] text-${formataDiferencaMesAtual(dados.percentualDiferencaMesAtualAnoAnteriorFilial).positivo ? 'green' : 'red'}-c1`}>
                                        {formataDiferencaMesAtual(dados.percentualDiferencaMesAtualAnoAnteriorFilial).arrow}{formataDiferencaMesAtual(dados.percentualDiferencaMesAtualAnoAnteriorFilial).msg}
                                    </label>
                                </h4>
                            </div>
                        </div>
                    </div>
                </div>

            )}

            <div className="niveis">
                {Array.isArray(dados.metas) && dados.metas.map((item, index) => (
                    <div key={index} className={`nivel-box ${item.nivel == dados.card.nivelRealizado ? 'nivel-principal' : ''} bg-nivel-${item.nivel}`}>
                        <div className="row-span-3 text-center px-1 py-8 rounded-t-[4px]">
                            <p className="text-[20px]">Nível {item.nivel}</p>
                            {(dados.cargo === 'VENDEDOR' && (item.meta_padrao !== item.meta)) && (<p className="text-2xl line-through">
                                {formatarValorMeta(item.meta_padrao)}
                            </p>)}
                            <p className="text-2xl">
                                {formatarValorMeta(item.meta)}
                            </p>
                            <p className="text-[13px]">em vendas</p>
                        </div>
                        <div className={`text-center ${(index === 0 || index === 1) ? 'border-t' : 'border-t border-black'} rounded-b-[4px]`}>
                            <p className="flex items-center justify-center h-full">+{item.pontos} pontos</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default DesempenhoAnimalUsuario